const loginService = function (forms, showNewAddressForm) {
	'use strict';

	const loginStatuses = {
		NotLoggedIn: 0,
		EmailExists: 1,
		NewCustomer: 2,
		LoggedIn: 3,
		EmailInvalid: 4,
		AccountSetup: 5
	};

	var loginStatus = loginStatuses.NotLoggedIn;

	const dataService = (function () {
		const antiForgeryToken = { 'RequestVerificationToken': document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value };
		const verificationToken = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value;
		const recaptchaSiteKey = document.getElementById('RecaptchaSiteKey').value;
		const recaptchaActionName = document.getElementById('RecaptchaActionName').value;

		const verifyEmail = function () {
			grecaptcha.execute(recaptchaSiteKey, { action: recaptchaActionName }).then(function (token) {
				uiService.ShowBusy();
				const data = getFormData(token);

				// ignore password validation at this step 
				data.Password = "****************";
				data.ConfirmPassword = data.Password;

				fetch('/checkout/verifyemail', {
					method: 'POST',
					body: JSON.stringify(data),
					headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": verificationToken }
				}).then(function (response) {
					return (response.ok) ? response.json() : []; // response.json() returns a promise
				}).then(function (response) {
					uiService.HideBusy();
					if (typeof response.exists === 'undefined') {
						document.getElementById("loginSection").innerHTML = response;
						uiService.Init();
					} else if (response.exists) {
						loginStatus = loginStatuses.EmailExists;
						uiService.Update();
					} else if (!response.exists && response.valid) {
						loginStatus = loginStatuses.NewCustomer;
						uiService.Update();
					} else if (!response.exists && !response.valid) {
						loginStatus = loginStatuses.EmailInvalid;
					}
				}).catch(function (error) {
					uiService.HideBusy();
					//console.log(response);
				});
			});
		};

		const login = function () {
			grecaptcha.execute(recaptchaSiteKey, { action: recaptchaActionName }).then(function (token) {
				uiService.ShowBusy();
				const data = getFormData(token);
				data.ConfirmPassword = data.Password;

				fetch('checkout/login', {
					method: 'POST',
					body: JSON.stringify(data),
					headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": verificationToken }
				}).then(function (response) {
					return (response.ok) ? response.text() : []; // response.json() returns a promise
				}).then(function (response) {
					if (!response.includes("errorMessage") && JSON.parse(response).url) {
						window.location.href = JSON.parse(response).url;
					} else if (response) {
						document.getElementById("loginSection").innerHTML = response;
						forms.BindPasswordButtons();
						uiService.Init();
					}
				}).catch(function (error) {
					uiService.HideBusy();
					//console.log(response);
				});
			});
		};

		const validateNewPassword = async function() {
			// Check if grecaptcha is defined
			// if not, try to fetch the script again 
			if(typeof grecaptcha == "undefined" && typeof get4iRecaptcha !== "undefined") await get4iRecaptcha();
			
			// need to show an error if recaptcha script still isn't available
			if(typeof grecaptcha == "undefined"){
				uiService.ShowError();
			}else{
				grecaptcha.execute(recaptchaSiteKey, { action: recaptchaActionName }).then(function(token) {
					uiService.ShowBusy();
					const data = getFormData(token);
	
					fetch('/checkout/validateNewPassword', { 
						method: 'POST', 
						body: JSON.stringify(data), 
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', '__RequestVerificationToken': verificationToken, 'RequestVerificationToken': verificationToken }
					}).then(function(response){
						return  (response.ok) ? response.json() : []; // response.json() returns a promise
					}).then(function(response){
						uiService.HideBusy();

						if(typeof response.isValid === 'undefined') {
							
						} else if (response.isValid) {
							loginStatus = loginStatuses.AccountSetup;
							uiService.Update();
						} else if (!response.isValid) {
							uiService.ShowPasswordErrors(response.errors);
						}
						return false; 
					}).catch(function(error){
						uiService.HideBusy();
						//console.log(error);
						return false;
					});
				});
			}
		};

		const getFormData = function (token) {
			const form = document.getElementById('checkoutRegisterForm');
			var data = {
				RecaptchaActionName: recaptchaActionName,
				RecaptchaToken: token
			};

			for (var i = 0; i < form.elements.length; i++) {
				if (form.elements[i].name) {
					data[form.elements[i].name] = form.elements[i].type !== 'checkbox' ? form.elements[i].value : form.elements[i].checked;
				}
			}

			return data;
		};

		return {
			VerifyEmail: verifyEmail,
			Login: login,
			ValidateNewPassword : validateNewPassword,
			GetFormData: getFormData
		};
	})();

	const uiService = (function () {
		const showPassword = function () {
			document.getElementById('passwordDiv').classList.remove('hide');
			document.getElementById('forgotDiv').classList.remove('hide');
			document.getElementById('LoginStatus').value = loginStatus;
			hideButton(document.getElementById('btnLogin'));
			showButton(document.getElementById('btnLoginSubmit'));

			const element = document.getElementById('Password');
			element.classList.add('txtReq');
			element.click();  // for form abandonment
			element.focus();

			element.addEventListener('keydown', manuallyClickSubmit);
		};

		const manuallyClickSubmit = function (e) {
			if ((e.which || e.keyCode) === 13) {
				document.getElementById('btnLoginSubmit').click();
			}
		};

		const showConfirmPassword = function () {
			document.getElementById('passwordDiv').classList.remove('hide');
			document.getElementById('confirmPasswordDiv').classList.remove('hide');
			document.getElementById('subscriptionDiv').classList.remove('hide');
			document.getElementById('LoginStatus').value = loginStatus;
			document.getElementById('ConfirmPassword').classList.add('txtReq');

			const element = document.getElementById('Password');
			element.classList.add('txtReq');
			element.click();  // for form abandonment
			element.focus();
		};

		const loadingIcon = '<div class="spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';

		const showBusy = function () {
			document.getElementById("loginStep").classList.remove('hide');
			document.getElementById("loginStep").querySelector(".busyIndicator").innerHTML = loadingIcon;
		};

		const hideBusy = function () {
			document.getElementById("loginStep").classList.add('hide');
			document.getElementById("loginStep").querySelector(".busyIndicator").innerHTML = "";
		};

		const wireCheckoutLoginLiveValidation = function () {
			const email = document.getElementById("Email");
			const pwd = document.getElementById("Password");
			const confirm = document.getElementById("ConfirmPassword");
			if (!email) return;

			const hidden = el => !el || el.classList.contains("visually-hidden");
			const getActiveBtn = () =>
				hidden(document.getElementById("btnLoginSubmit"))
					? document.getElementById("btnLogin")
					: document.getElementById("btnLoginSubmit");

			const emailValid = v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || "").trim());
			const pwdMin = (() => {
				const v = pwd?.getAttribute("data-val-length-min");
				const n = parseInt(v || "8", 10);
				return isNaN(n) ? 8 : n;
			})();
			const pwdValid = v => (v || "").length >= pwdMin;
			const confirmValid = () => (confirm ? confirm.value === (pwd?.value || "") : true);

			const wantEnabled = () => {
				switch (loginStatus) {
					case loginStatuses.NotLoggedIn:
					case loginStatuses.EmailInvalid:
						return emailValid(email.value);
					case loginStatuses.EmailExists:
						return emailValid(email.value) && pwd && pwdValid(pwd.value);
					case loginStatuses.NewCustomer:
						return emailValid(email.value) && pwd && pwdValid(pwd.value) && confirmValid();
					default:
						return false;
				}
			};

			const sync = () => {
				const btn = getActiveBtn();
				if (!btn) return;
				const ok = wantEnabled();

				// Keep logical enable/disable
				btn.disabled = !ok;
				btn.setAttribute("aria-disabled", String(!ok));

				// Always blue for accessibility consistency
				btn.classList.add("bkgdBlue");
				btn.classList.remove("bkgdLtGray");

				// Optional: dim with .disabled style if CSS uses it for opacity or cursor
				btn.classList.toggle("disabled", !ok);

			};

			const bind = el => el && ["input", "blur", "change"].forEach(ev => el.addEventListener(ev, sync));
			bind(email); bind(pwd); bind(confirm);

			sync();                 // initial
			setTimeout(sync, 0);    // after DOM paints
			setTimeout(sync, 300);  // after autofill
			setTimeout(sync, 1000); // slower autofill
		};

		const init = function () {
			const continueBtn = document.getElementById('btnLogin');
			const submitBtn = document.getElementById('btnLoginSubmit');
			const status = document.getElementById('LoginStatus');
			const email = document.getElementById('Email');
			const form = document.getElementById("checkoutRegisterForm");

			if (submitBtn && continueBtn) {
				submitBtn.addEventListener('click', function (e) {
					buttonClick(e, form);
				});

				continueBtn.addEventListener('click', function (e) {
					buttonClick(e, form);
				});
			}

			if (email) {
				email.addEventListener('change', function (e) {
					if (loginStatus !== loginStatuses.NotLoggedIn) {
						loginStatus = loginStatuses.NotLoggedIn;
						hideErrorMessage();
						update();
					}
				});
			}

			if (status && status.value !== '0') {
				loginStatus = parseInt(status.value);
				update();
			}
			wireCheckoutLoginLiveValidation();
		};

		const buttonClick = function (e, form) {
			switch (loginStatus) {
				case loginStatuses.NotLoggedIn:
				case loginStatuses.EmailInvalid:
					e.preventDefault();
					forms.formValidation(form, dataService.VerifyEmail, e);
					break;

				case loginStatuses.EmailExists:
					e.preventDefault();
					forms.formValidation(form, dataService.Login, e);
					break;

				case loginStatuses.NewCustomer:
					e.preventDefault();
					forms.formValidation(form, dataService.ValidateNewPassword, e);
					break;

				default:
			}
		};

		const hideErrorMessage = function () {
			const element = document.getElementById("ErrorBox");
			if (document.getElementById("ErrorBox")) {
				element.remove();
			}
		};

		const update = function () {
			switch (loginStatus) {
				case loginStatuses.NotLoggedIn:
					reset();
					document.getElementById("loginHeader").innerHTML = document.getElementById("EnterEmailHeader").value;
					break;

				case loginStatuses.EmailExists:
					showPassword();
					document.getElementById("loginHeader").innerHTML = document.getElementById("ReturnCustHeader").value;

					break;

				case loginStatuses.NewCustomer:
					showConfirmPassword();
					document.getElementById("loginHeader").innerHTML = document.getElementById("NewCustHeader").value;
					break;

				case loginStatuses.AccountSetup:
					showNotification();
					break;
				default:
			}
			wireCheckoutLoginLiveValidation();
		};

		const reset = function () {
			document.getElementById('passwordDiv').classList.add('hide');
			document.getElementById('forgotDiv').classList.add('hide');
			document.getElementById('confirmPasswordDiv').classList.add('hide');
			document.getElementById('subscriptionDiv').classList.add('hide');
			document.getElementById('LoginStatus').value = loginStatus;
			document.getElementById('ConfirmPassword').classList.remove('txtReq');
			hideButton(document.getElementById('btnLoginSubmit'));

			const element = document.getElementById('Password');
			element.classList.remove('txtReq');
			element.removeEventListener('keydown', manuallyClickSubmit);

			const button = document.getElementById('btnLogin');
			showButton(button);
			button.focus();
		};

		const showNotification = function () {
			document.getElementById('formBody').classList.add('hide');
			document.getElementById('accountNotification').classList.remove('hide');
			var element = document.getElementById('accountNotificationSpan');
			element.innerHTML = element.innerHTML.replace('##email##', document.getElementById('Email').value);
			showNewAddressForm();
		};

		const showButton = function (button) {
			button.classList.remove('visually-hidden');
			button.disabled = false;
		};

		const hideButton = function (button) {
			button.classList.add('visually-hidden');
			button.disabled = true;
		};

		const validSetup = function () {
			loginStatus = loginStatuses.AccountSetup;
			update();
		};

		const showPasswordErrors = function(errors) {
			const formHeadingDiv = document.querySelector('.formHeading');
				if (formHeadingDiv) {
					formHeadingDiv.insertAdjacentHTML('afterend', errors);
				}
		}

		return {
			Init: init,
			Update: update,
			ShowBusy: showBusy,
			HideBusy: hideBusy,
			ShowPasswordErrors : showPasswordErrors
		};
	})();

	uiService.Init();

	return {
		get LoginStatuses() { return loginStatuses; },
		set SetLoginStatus(status) { loginStatus = status; },
		get GetLoginStatus() { return loginStatus; },
		GetFormData: dataService.GetFormData
	};
};